import { Text } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

interface TableContentItemPercentageProps {
  children: number;
}

export const TableContentItemPercentage: React.FC<TableContentItemPercentageProps> = ({
  children,
}) => {
  return (
    <Box
      px={Spacing['inline.nano']}
      py={Spacing['inline.quarck']}
      bgColor={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 'opacity.intense')}
      borderRadius={BoxRadius.sm}>
      <Text variant="bold" color="brand.tertiary.dark">
        {Utils.Mask.Percentage(children)}
      </Text>
    </Box>
  );
};
